import type { ValidatorType } from "shelving";
import { DATA, INTEGER, formatDate, pickProps } from "shelving";
import { REQUIRED_IMAGES } from "../util/media.js";
import { PRIVACY } from "../util/privacy.js";
import { CREATOR_ENTITY, ENTITIES } from "./entity.js";
import { CONTENT } from "./misc.js";

export const POSTS_MAX = 48;
export const COMMENTS_MAX = 48;

/**
 * Posts: store individual posts by users.
 * - Stored at `posts/{id}`
 */
export const POST_SCHEMA = DATA({
	creator: CREATOR_ENTITY, // ID of the user who wrote this post.
	date: INTEGER,
	privacy: PRIVACY,
	images: REQUIRED_IMAGES,
	content: CONTENT,
	tags: ENTITIES, // Any `@tags` or `#tags` found in `content`
	links: ENTITIES, // List of linked entites, e.g. the challenge this post relates to.
	replies: INTEGER, // Number of comments replying directly to this post.
	reactions: INTEGER, // Number of reactions of diferent types on this post.
});
export type PostData = ValidatorType<typeof POST_SCHEMA>;

/** Form to create a post. */
export const POST_FORM_SCHEMA = DATA(pickProps(POST_SCHEMA.props, "content", "privacy", "images", "links"));
export type PostFormData = ValidatorType<typeof POST_FORM_SCHEMA>;

/** Title for a post page. */
export const getPostTitle = ({ date }: PostData): string => `Post on ${formatDate(date)}`;
